import client from "lib/apolloClient/client";

import { supervisorFragments } from "Projects/modules/ProjectFragments";

export const writeExternalSupervisorInfoInCache = ({ id, data }) => {
  try {
    client.writeFragment({
      id: `Staff:${id}`,
      fragment: supervisorFragments.supervisorInfoFragmentV2,
      fragmentName: "SupervisorInfoItemV2",
      data: data,
    });
  } catch (e) {
    console.warn("could not write", e);
    return {};
  }
};

export const getExternalSupervisorInfoFromCache = ({ id }) => {
  try {
    const data = client.readFragment({
      id: `Staff:${id}`,
      fragment: supervisorFragments.supervisorInfoFragmentV2,
      fragmentName: "SupervisorInfoItemV2",
    });
    return data;
  } catch (e) {
    console.warn("could not read", e);
    return {};
  }
};
